import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

const PageContainer = ({ title, description, children }) => {
  const { t } = useTranslation();

  return (
    <div>
      <Helmet>
        <title>{t(title)}</title>
        <meta name="description" content={t(description)} />
      </Helmet>
      {children}
    </div>
  );
};

PageContainer.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  children: PropTypes.node
};

export default PageContainer;
